import { render, staticRenderFns } from "./PrintPosFaR2.vue?vue&type=template&id=c165a5f6&scoped=true"
import script from "./PrintPosFaR2.vue?vue&type=script&lang=js"
export * from "./PrintPosFaR2.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaR2.vue?vue&type=style&index=0&id=c165a5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c165a5f6",
  null
  
)

export default component.exports